import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SESSION_TOKEN_KEY } from '../config.js';

const AUTH_ERRORS = {
  USER_NOT_CREATED: 'user_not_created',
  ACCOUNT_INACTIVE: 'account_inactive',
  DOMAIN_NOT_ALLOWED: 'domain_not_allowed',
  EMAIL_NOT_AVAILABLE: 'email_not_available',
};

function isSafeReturnTo(returnTo) {
  if (!returnTo || typeof returnTo !== 'string') return false;
  if (!returnTo.startsWith('/')) return false;
  if (returnTo.startsWith('//')) return false;
  if (returnTo.includes('://')) return false;
  return true;
}

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Signing you in...');

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');
    const code = searchParams.get('code');
    const email = searchParams.get('email');
    const returnToParam = searchParams.get('returnTo');
    const returnTo = isSafeReturnTo(returnToParam) ? returnToParam : '/';

    if (token) {
      try {
        // localStorage seulement, sous une clé DÉDIÉE : l'ancien emplacement
        // `authToken` (cookie .globe-groupe.com compris) est celui de l'auth Basic
        // legacy, que toutes les apps purgent désormais — un jeton rangé là serait
        // effacé, et un cookie domaine-entier fuiterait vers les apps sœurs.
        localStorage.setItem(SESSION_TOKEN_KEY, token);
        window.location.replace(returnTo);
      } catch (e) {
        setMessage('Sign-in failed (unable to persist session).');
      }
      return;
    }

    if (code) {
      setMessage('Received an OAuth code on the frontend. This usually means the identity provider redirect URI points to the frontend. Configure it to redirect to the backend `/auth/callback`.');
      return;
    }

    if (error) {
      let nextMessage = `Sign-in failed: ${error}`;
      switch (error) {
        case AUTH_ERRORS.USER_NOT_CREATED:
          nextMessage = `User not created${email ? `: ${email}` : ''}`;
          break;
        case AUTH_ERRORS.ACCOUNT_INACTIVE:
          nextMessage = 'Your account is not active.';
          break;
        case AUTH_ERRORS.DOMAIN_NOT_ALLOWED:
          nextMessage = 'This account is not allowed.';
          break;
        case AUTH_ERRORS.EMAIL_NOT_AVAILABLE:
          nextMessage = 'Unable to retrieve your email from the identity provider.';
          break;
        default:
          break;
      }
      setMessage(nextMessage);
      return;
    }

    setMessage('Sign-in failed.');
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-2">OAuth</h1>
        <div className="text-gray-700 dark:text-gray-200">{message}</div>
      </div>
    </div>
  );
}

